class ApiService {
  constructor() {
    this.baseUrl = 'https://iurqddkuihjsmxubibao.supabase.co/rest/v1';
    this.apiKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml1cnFkZGt1aWhqc214dWJpYmFvIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTczMjYzNTE3MywiZXhwIjoyMDQ4MjExMTczfQ.hQA1bfHFtWkCw63Uhi535vDEO9cydjt7DDLc-oidv78';
    this.authToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml1cnFkZGt1aWhqc214dWJpYmFvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzI2MzUxNzMsImV4cCI6MjA0ODIxMTE3M30.KNNp_wFMSDWOuDlvWs2xuuzC5wj-d3saoc-8zQ4AkN4';
  }

  async fetchProdutos() {
    try {
      const response = await fetch(`${this.baseUrl}/produtos?select=*`, {
        method: 'GET',
        headers: {
          'apikey': this.apiKey,
          'Authorization': `Bearer ${this.authToken}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Erro na requisição: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erro ao buscar produtos da API:', error);
      throw error;
    }
  }

  async updateLocalJsonFile() {
    try {
      console.log('🔄 Iniciando atualização do arquivo JSON...');
      
      // Buscar dados da API
      const produtos = await this.fetchProdutos();
      
      // Filtrar apenas produtos da empresa específica
      const produtosEmpresa = produtos.filter(produto => 
        produto.empresa === '1728965891007x215886838679286700'
      );

      console.log(`📊 Encontrados ${produtosEmpresa.length} produtos da empresa`);

      // Salvar no arquivo local usando fetch para simular uma requisição POST
      // Em um ambiente real, você faria uma requisição POST para salvar o arquivo
      try {
        // Tentar salvar o arquivo usando uma requisição POST (simulado)
        const saveResponse = await fetch('/api/update-json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            data: produtosEmpresa,
            filename: '1728965891007x215886838679286700.json'
          })
        });

        if (saveResponse.ok) {
          console.log('✅ Arquivo salvo com sucesso');
        } else {
          console.log('⚠️ Não foi possível salvar o arquivo, mas os dados foram atualizados em memória');
        }
      } catch (saveError) {
        console.log('⚠️ Erro ao salvar arquivo:', saveError.message);
        console.log('📝 Os dados foram atualizados em memória e podem ser exportados');
      }
      
      return {
        success: true,
        message: `Dados atualizados com ${produtosEmpresa.length} produtos da API`,
        data: produtosEmpresa,
        timestamp: new Date().toISOString(),
        totalFromApi: produtos.length,
        empresaProducts: produtosEmpresa.length
      };
    } catch (error) {
      console.error('❌ Erro ao atualizar arquivo JSON:', error);
      throw error;
    }
  }

  async checkForUpdates() {
    try {
      const produtos = await this.fetchProdutos();
      const produtosEmpresa = produtos.filter(produto => 
        produto.empresa === '1728965891007x215886838679286700'
      );
      
      return {
        totalProdutos: produtosEmpresa.length,
        lastUpdate: new Date().toISOString(),
        hasUpdates: true // Sempre retorna true por simplicidade
      };
    } catch (error) {
      console.error('Erro ao verificar atualizações:', error);
      throw error;
    }
  }
}

const apiService = new ApiService();
export default apiService;
